import * as React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import Footer from "./Footer";
import Header from "./Header";
import { useSiteMetadata } from "../utilities/siteMetadataHook";

const Layout = ({
  pageTitle,
  location,
  children,
  noindex = false,
  nofollow = false,
  headerRightElement = "searchBox",
}) => {
  const { siteUrl } = useSiteMetadata();
  return (
    <>
      <GatsbySeo
        title={
          pageTitle ||
          `Founder's Book Shelf: Find books you need to grow your startup`
        }
        nofollow={nofollow}
        noindex={noindex}
        language={"en"}
        description="Find books you need to grow your startup"
        canonical={location ? `${siteUrl}${location}` : `${siteUrl}`}
        twitter={{
          handle: "@_smanna",
          site: "@_smanna",
          cardType: "summary_large_image",
        }}
      />
      <title></title>
      <div className="flex flex-col mx-auto sm:w-full md: max-w-screen-md lg:max-w-screen-lg mb-6">
        <Header rightElement={headerRightElement} />
        <div className="layout-content px-4">{children}</div>
      </div>
      <Footer />
    </>
  );
};

export default Layout;
